import type { EqBuilderUiActions, StoreSlice, UiState } from '../types'

const initialUiState: UiState = {
  expandedFamilies: new Set<string>()
} as const

export const createUiSlice: StoreSlice<UiState & EqBuilderUiActions> = set => ({
  // State
  ...initialUiState,
  // Actions
  setExpandedFamilies: val =>
    set(
      state => {
        const currentSet = state.expandedFamilies
        currentSet.add(val)
        return { expandedFamilies: currentSet }
      },
      false,
      'setExpandedFamilies'
    ),

  setExpandedFamiliesByKey: key =>
    set(
      state => {
        const expandedFamilies = new Set(state.expandedFamilies)
        if (expandedFamilies.has(key)) {
          expandedFamilies.delete(key)
        } else {
          expandedFamilies.add(key)
        }
        return { expandedFamilies }
      },
      false,
      'setExpandedFamiliesByKey'
    ),

  closeExpandedFamily: key =>
    set(
      state => {
        const currentSet = new Set(state.expandedFamilies)
        currentSet.delete(key)
        return { expandedFamilies: currentSet }
      },
      false,
      'closeExpandedFamily'
    ),

  setSectionsErrors: val =>
    set(
      state => ({
        sectionsErrors: {
          ...state.sectionsErrors,
          ...val
        }
      }),
      false,
      'setSectionsErrors'
    ),
  resetUi: () => set(initialUiState)
})
